import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import NotFound from '@/pages/not-found'
import { ErrorFallback } from '@/pages/error-fallback'
import { QueryClient } from '@tanstack/react-query'

interface RouterContext {
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
    </>
  ),
  notFoundComponent: NotFound,
  errorComponent: ErrorFallback,
})
